import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BaseResponse } from '../../models/response/base-response';

enum posicaoMensagem {
  topRight = 'top-right',
  topLeft = 'top-left',
  bottomRight = 'bottom-right',
  bottomLeft = 'bottom-left',
  topCenter = 'top-center',
  bottomCenter = 'bottom-center',
  center = 'center',
}

enum severity {
  sucesso = 'success',
  erro = 'error',
  info = 'info',
  aviso = 'warning',
}

@Injectable({
  providedIn: 'root',
})
export class AvisoService {
  private readonly messageService = inject(MessageService);

  abrirBaseResponse<T>(
    baseResponse: BaseResponse<T>,
    _titulo?: string,
    _posicao?: posicaoMensagem,
    _gravidade?: severity,
    tempo = 2,
  ) {
    if (baseResponse.status) {
      this.Sucesso(baseResponse.mensagem, undefined, undefined, undefined, tempo);
    } else {
      this.Erro(baseResponse.mensagem, undefined, undefined, undefined, tempo);
    }
  }

  Erro(
    mensagem: string,
    titulo = 'Erro',
    _posicao?: posicaoMensagem,
    gravidade: severity = severity.erro,
    tempo = 3,
  ): void {
    this.messageService.add({
      severity: gravidade,
      summary: titulo,
      detail: mensagem,
      life: tempo * 1000,
    });
  }

  Info(
    mensagem: string,
    titulo = 'Atenção',
    _posicao?: posicaoMensagem,
    gravidade: severity = severity.info,
    tempo = 3,
  ): void {
    this.messageService.add({
      severity: gravidade,
      summary: titulo,
      detail: mensagem,
      life: tempo * 1000,
    });
  }

  Sucesso(
    mensagem: string,
    titulo = 'Sucesso',
    _posicao?: posicaoMensagem,
    gravidade: severity = severity.sucesso,
    tempo = 3,
  ): void {
    this.messageService.add({
      severity: gravidade,
      summary: titulo,
      detail: mensagem,
      life: tempo * 1000,
    });
  }
}
